import ManagerNotesQuestion from '../components/ManagerNotesQuestion';
import InformationPageTemplate from '../components/InformationPageTemplate';
import { State } from '../redux-state';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useLocation, useParams } from 'react-router-dom';

const ManagerNotesPage: React.FC = (): React.ReactElement => {
    const { t } = useTranslation(['ManagerNotes']);
    const { survey_id, uid } = useParams();
    let emailAuth;
    const location = useLocation();
    const stateVar = location.state;
    if (stateVar && 'emailAuth' in stateVar) {
        emailAuth = stateVar.emailAuth;
    }

    const data = useSelector(
        (state: State) => state.managerNotesState || { questions: [], answers: [] },
    );

    return (
        <InformationPageTemplate
            tagline={t('title') || ''}
            content={''}
            middleImage={''}
            nextText="no-next"
            previousPath={`/${survey_id}/${uid}/mandatory-welcome`}
            logoImage="/talentbuilderlogo.png"
            emailAuth={emailAuth}
            controls={false}
        >
            <ManagerNotesQuestion
                questions={data.questions}
                answers={data.answers}
            />
        </InformationPageTemplate>
    );
};

export default ManagerNotesPage;
